// ---------------------
// Add To Cart Button
// ---------------------
if (!customElements.get('add-to-cart-button')) {
  class AddToCartButton extends HTMLElement {
    constructor() {
      super();
      this.variantId = parseInt(this.dataset.variantId, 10);
      this.button = this.querySelector('button') || this;

      // 创建 tooltip
      this.tooltip = document.createElement('div');
      this.tooltip.style.cssText = `
        position:absolute; padding:6px 10px; background:rgba(0,0,0,0.8); color:#fff;
        font-size:12px; border-radius:4px; white-space:nowrap; z-index:9999;
        opacity:0; transition:opacity 0.3s; pointer-events:none;
      `;
      document.body.appendChild(this.tooltip);
    }

    connectedCallback() {
      if (!this.variantId) return;
      this.updateStateFromCart();
      this.button.addEventListener('click', (event) => this.handleClick(event));
    }

    handleClick(event) {
      if (event) event.preventDefault();

      // 已加购 → 显示 tooltip，不刷新页面
      if (this.button.dataset.added === 'true') {
        this.showTooltip('You have successfully added the product to the shopping cart!');
        return;
      }

      // 未加购 → 加入购物车
      this.button.disabled = true;
      this.button.textContent = 'Adding...';

      fetch(`${theme.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
        body: JSON.stringify({ items:[{id:this.variantId, quantity:1}] })
      })
      .then(res => res.json())
      .then(() => {
        this.button.dataset.added = 'true';
        this.button.textContent = 'Added';
        this.button.disabled = false;

        // 滑动到顶部后刷新页面
        //window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(() => location.reload(), 200);
      })
      .catch(() => {
        this.button.disabled = false;
        this.button.textContent = 'Add to cart';
      });
    }

    updateStateFromCart() {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const inCart = cart.items.some(i => i.variant_id === this.variantId);
          this.button.dataset.added = inCart ? 'true' : 'false';
          this.button.textContent = inCart ? 'Added' : 'Add to cart';
          this.button.disabled = false;
        })
        .catch(err => console.error('Error fetching cart:', err));
    }

    showTooltip(msg) {
      this.tooltip.textContent = msg;
      const rect = this.button.getBoundingClientRect();
      const tooltipWidth = this.tooltip.offsetWidth;
      const tooltipMargin = 8; // 屏幕边距

      let left = window.scrollX + rect.left + rect.width / 2 - tooltipWidth / 2;
      if (left < tooltipMargin) left = tooltipMargin;
      if (left + tooltipWidth > window.scrollX + window.innerWidth - tooltipMargin) {
        left = window.scrollX + window.innerWidth - tooltipWidth - tooltipMargin;
      }

      this.tooltip.style.top = `${window.scrollY + rect.bottom + 6}px`;
      this.tooltip.style.left = `${left}px`;
      this.tooltip.style.opacity = '1';

      clearTimeout(this._tooltipTimeout);
      this._tooltipTimeout = setTimeout(() => { this.tooltip.style.opacity = '0'; }, 2000);
    }
  }

  customElements.define('add-to-cart-button', AddToCartButton);
}

// ---------------------
// 全局检查购物车
// ---------------------
/*
function checkAndClearCartGlobal() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      if (!cart.items || cart.items.length === 0) return;

      const grid = document.querySelector('.add-on-items-grid');
      if (!grid) return;

      const addonIds = grid.dataset.addOnIds
        ? grid.dataset.addOnIds.split(',').map(s => parseInt(s.trim(), 10)).filter(Boolean)
        : [];
      const specialIds = grid.dataset.specialIds
        ? grid.dataset.specialIds.split(',').map(s => parseInt(s.trim(), 10)).filter(Boolean)
        : [];

      const allowedIds = Array.from(new Set([...addonIds, ...specialIds]));
      if (allowedIds.length === 0) return;

      const cartProducts = cart.items.map(i => i.product_id);
      const allAreAllowed = cartProducts.every(vId => allowedIds.includes(vId));

      if (allAreAllowed) {
        fetch('/cart/clear.js', { method: 'POST' })
          .then(() => location.reload())
          .catch(() => location.reload());
      }
    })
    .catch(error => console.error('Error checking cart:', error));
}

// 初始化
document.addEventListener('DOMContentLoaded', checkAndClearCartGlobal);
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', checkAndClearCartGlobal);
}
*/